// ---------------- VARIABLES ----------------
let accessToken = null;
let tokenExp = null;

// ---------------- SETTERS ----------------
export const setAccessToken = (token) => {
  accessToken = token;
};
export const setTokenExp = (exp) => {
  tokenExp = exp;
};

// ---------------- GETTERS ----------------
export const getAccessToken = () => accessToken;
export const getTokenExp = () => tokenExp;
